unit uLockerDataStore;

interface

uses
  System.SysUtils, System.Classes, WEBLib.JSON;

type
  TLockerData = class
  private
    FLockerID: string;
    FJsonData: TJSONObject;
  public
    constructor Create;
    destructor Destroy; override;
    property LockerID: string read FLockerID write FLockerID;
    property JsonData: TJSONObject read FJsonData write FJsonData;
  end;

  TLockerDataStore = class abstract
  public
    [async] function Add(AData: TJSONObject): Boolean; async; virtual; abstract;
    [async] function Read(): TLockerData; async; virtual; abstract;
    [async] function Update(AData: TJSONObject): Boolean; async; virtual; abstract;
    [async] function Delete(): Boolean; async; virtual; abstract;
    [async] function AddOrUpdate(AData: TJSONObject): Boolean; async; virtual; abstract;

    function GetLockerID: string; virtual; abstract;
    property LockerID: string read GetLockerID;
  end;

implementation

constructor TLockerData.Create;
begin
  inherited;
  FJsonData := TJSONObject.Create;
end;

destructor TLockerData.Destroy;
begin
  FJsonData.Free;
  inherited;
end;

end.
